import { useMemo } from "react"
import { useParams } from "react-router-dom"
import { TopicCards, TopicCardsSkeleton, useTopics } from "@/entities/taxonomy"
import { TaxonomyPostsPage } from "@/widgets/taxonomy-posts"

export function TopicPage() {
	const { id } = useParams<{ id: string }>()
	const { data: topics = [], isLoading: topicsLoading } = useTopics()

	const topic = useMemo(() => {
		if (!id || !topics.length) return null
		return topics.find((t) => t.id === id)
	}, [id, topics])

	return (
		<TaxonomyPostsPage
			entityId={id}
			entity={topic}
			taxonomyLoading={topicsLoading}
			filterKey="topicId"
			notFoundMessage="Тема не найдена"
			kindLabel="Тема"
			railTitle="Темы"
			emptyMessage="Нет постов по этой теме"
			rail={
				topicsLoading ? (
					<TopicCardsSkeleton />
				) : (
					<TopicCards topics={topics} selectedTopicId={topic?.id} />
				)
			}
		/>
	)
}
